import { JiraTicketSubmittionComponent } from './petsafe-components/jira-ticket-submittion/jira-ticket-submittion.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { AuthGuardService } from './services/util/auth-guard.service';
import { SearchResultsComponent } from './petsafe-components/user/search-results/search-results.component';
import { CustomerComponent } from './petsafe-components/user/customer/customer.component';
import { HelpComponent } from './petsafe-components/help/help.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuardService],
  },
  { path: 'login', component: LoginComponent },
  {
    path: 'search/:term',
    component: SearchResultsComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'customer/:id',
    component: CustomerComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'customer/:id/:product',
    component: CustomerComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'help',
    component: HelpComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'help/:category',
    component: HelpComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'jira',
    component: JiraTicketSubmittionComponent,
    canActivate: [AuthGuardService],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
